<template>
  <div class="main-header-component">
    <div class="header__title t-text-color">{{ $store.getters.settings.appName }}</div>
    <nav>
      <ul class="header-menu">
        <li>
          <div class="header-menu__item">{{$auth.user().name}}</div>
        </li>
        <li>
          <a class="header-menu__item" href="#" @click.prevent="logout">Logout</a>
        </li>
        <li v-if="$store.getters.settings.client.bilingual">
          <a class="header-menu__item language-toggle" :href="switchPath">عربي</a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
  export default {
    computed: {
      switchPath () {
        return '/ar' + this.$route.path
      }
    },
    methods: {
      logout () {
        this.$auth.logout({
          redirect: {name: 'Login'}
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue